import usePermiso from "../../hooks/usePermiso";

import { usePropiedadUi } from "../../hooks/usePropiedadUi";

const CAMPOS_REGISTRO = [
  { label: "Registro de", name: "reg_registro_de", nodeId: "reg_registro_de" },
  { label: "Nº Registro", name: "reg_num_registro", nodeId: "reg_num_registro" },
  { label: "Tomo", name: "reg_tomo", nodeId: "tomo_libro_folio_finca" },
  { label: "Libro", name: "reg_libro", nodeId: "tomo_libro_folio_finca" },
  { label: "Folio", name: "reg_folio", nodeId: "tomo_libro_folio_finca" },
  { label: "Finca", name: "reg_finca", nodeId: "tomo_libro_folio_finca" },
  { label: "Inscripción", name: "reg_inscripcion", nodeId: "reg_inscripcion" },
  { label: "Ref. Catastral", name: "reg_ref_catastral", nodeId: "catastro_ref" },
  { label: "UTM", name: "reg_utm", nodeId: "reg_utm" },
  { label: "IDUFIR", name: "reg_idufir", nodeId: "reg_idufir" },
  { label: "Valor de Referencia", name: "reg_valor_referencia", nodeId: "reg_valor_referencia" },
  { label: "Año Construcción Registro", name: "reg_ano_construccion", nodeId: "reg_ano_construccion" },
];

export default function SeccionRegistro(props) {

  const { form, cambiar } = props;

  const { tv } = usePropiedadUi(props);

  const { puede } = usePermiso();

  const perm = (nodeId) => ({
    ver: puede(nodeId, "ver"),
    modificar: puede(nodeId, "modificar"),
  });

  const field = (label, name, nodeId, span) => {
    const { ver, modificar } = perm(nodeId);
    if (!ver) return null;
    return (
      <div className={"flex flex-col gap-1" + (span ? " col-span-" + span : "")}>
        <label className="text-xs font-medium text-gray-500">{tv(label)}</label>
        <input
          type="text"
          name={name}
          value={form[name] || ""}
          onChange={cambiar}
          disabled={!modificar}
          title={!modificar ? "No tienes permiso para modificar" : undefined}
          className={"px-2 py-1.5 border border-gray-300 rounded-lg text-sm bg-white" + (!modificar ? " opacity-60 cursor-not-allowed" : "")}
        />
      </div>
    );
  };

  const textarea = (label, name, nodeId, rows = 2) => {
    const { ver, modificar } = perm(nodeId);
    if (!ver) return null;
    return (
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-500">{tv(label)}</label>
        <textarea
          name={name}
          value={form[name] || ""}
          onChange={cambiar}
          rows={rows}
          disabled={!modificar}
          title={!modificar ? "No tienes permiso para modificar" : undefined}
          className={"px-2 py-1.5 border border-gray-300 rounded-lg text-sm resize-y bg-white" + (!modificar ? " opacity-60 cursor-not-allowed" : "")}
        />
      </div>
    );
  };

  return (

    <div>

      <h2 className="font-bold text-gray-700 mb-4 text-sm uppercase tracking-wide">{tv("Datos Registro")}</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">

        {CAMPOS_REGISTRO.map((c) => field(c.label, c.name, c.nodeId))}

      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">

        {textarea("Título", "reg_titulo", "reg_titulo")}

        {textarea("Cargas", "reg_cargas", "cargas")}

        {textarea("Gastos", "reg_gastos", "reg_gastos")}

        {perm("reg_sup_catastro").ver && field("Sup. Catastro", "reg_sup_catastro", "reg_sup_catastro")}

      </div>

      <div className="mt-3">
        {textarea("Observaciones", "reg_observaciones", "reg_observaciones", 3)}
      </div>

    </div>

  );

}
